import { memo, VFC } from 'react'
import { withMediaQuery } from 'src/components/hoc/withMediaQuery'
import { LANDSCAPE_MIN_WIDTH } from 'src/styles/mixins'
import { HEADER } from 'src/utils/zIndex'
import styled, { css } from 'styled-components'
import { SalesDemoAlertBanner } from '../Banner/SalesDemoAlertBanner'
import { BreadCrumb, BreadCrumbProps } from '../BreadCrumb'
import { TopPageBanner } from '../TopPageBanner'
import { GuestNarrowHeader, MemberNarrowHeader } from './NarrowHeader'
import { MemberHeaderContentProps } from './types'
import { GuestWideHeader, MemberWideHeader } from './WideHeader'
import { HEADER_HEIGHT } from './WideHeader/HeaderWrapper'

export type MemberHeaderProps = MemberHeaderContentProps &
  Partial<BreadCrumbProps> & {
    shouldDisplayBanner?: boolean
    displayBreadCrumb?: boolean
  }

export const MemberHeader: VFC<MemberHeaderProps> = memo(
  ({
    user,
    currentPath,
    parentPaths,
    color,
    shouldDisplayBanner,
    displayBreadCrumb = true,
  }) => {
    const bannerDisplayPages = [
      'マイページ',
      'アポイント・評価',
      'イベント一覧',
      '今日のAIピック',
      '掲示板',
      '決裁者を探す',
    ]
    const shouldDisplaySalesDemoAlertBanner =
      user.plan.salesDemo &&
      currentPath &&
      bannerDisplayPages.includes(currentPath)
    return (
      <>
        <StyledHeader>
          <MemberHeaderContent user={user} />
        </StyledHeader>
        {currentPath && (
          <>
            <Spacer />
            {shouldDisplaySalesDemoAlertBanner && (
              <SalesDemoAlertBanner
                salesDemoDaysLeftText={user.salesDemoDaysLeftText}
              />
            )}
            {displayBreadCrumb && (
              <BreadCrumbWrapper>
                <BreadCrumbDiv color={color}>
                  <BreadCrumb
                    currentPath={currentPath}
                    parentPaths={parentPaths}
                  />
                </BreadCrumbDiv>
              </BreadCrumbWrapper>
            )}
            {shouldDisplayBanner && (
              <TopPageBanner free={user.plan.freeAndPartner} />
            )}
          </>
        )}
      </>
    )
  },
)

export const GuestHeader: VFC<Partial<BreadCrumbProps>> = ({
  currentPath,
  parentPaths,
  color,
}) => (
  <>
    <StyledHeader>
      <GuestHeaderContent />
    </StyledHeader>
    {currentPath && (
      <>
        <Spacer />
        <BreadCrumbWrapper>
          <BreadCrumbDiv color={color}>
            <BreadCrumb currentPath={currentPath} parentPaths={parentPaths} />
          </BreadCrumbDiv>
        </BreadCrumbWrapper>
      </>
    )}
  </>
)

const MemberHeaderContent = withMediaQuery({
  WideComponent: MemberWideHeader,
  NarrowComponent: MemberNarrowHeader,
  wideMinWidth: LANDSCAPE_MIN_WIDTH,
})

const GuestHeaderContent = withMediaQuery({
  WideComponent: GuestWideHeader,
  NarrowComponent: GuestNarrowHeader,
  wideMinWidth: LANDSCAPE_MIN_WIDTH,
})

const StyledHeader = styled.header`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: ${HEADER};
`
const Spacer = styled.div`
  @media screen and (min-width: ${LANDSCAPE_MIN_WIDTH}px) {
    padding-top: ${HEADER_HEIGHT};
  }
  padding-top: 45px;
`
const BreadCrumbWrapper = styled.div`
  position: relative;
`
const BreadCrumbDiv = styled.div`
  position: absolute;
  top: 10px;
  left: 20px;
  font-size: 12px;
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `};

  @media screen and (min-width: 1024px) {
    left: 50px;
    font-size: 14px;
  }
`
